import { Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-rizes-olive text-rizes-ivory">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
        <div className="grid grid-cols-1 items-start gap-8 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr] lg:gap-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="font-serif text-3xl text-white">Rizes Sifnos</h3>
            <p className="max-w-sm leading-7 text-rizes-limestone">
              A quiet house in Rizes, Sifnos. Two bedrooms, close to Apollonia.
            </p>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-rizes-limestone" />
                <span className="text-rizes-ivory">+30 698 370 6589</span>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="mt-1 h-5 w-5 text-rizes-limestone" />
                <span className="text-rizes-ivory">Rizes, Sifnos, Greece</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-rizes-limestone hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-rizes-olive focus:ring-offset-2">
                  Home
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-rizes-limestone hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-rizes-olive focus:ring-offset-2">
                  Gallery
                </a>
              </li>
              <li>
                <a href="#book" className="text-rizes-limestone hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-rizes-olive focus:ring-offset-2">
                  Book Now
                </a>
              </li>
              <li>
                <a href="#contact" className="text-rizes-limestone hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-rizes-olive focus:ring-offset-2">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 border-t border-rizes-limestone/20 pt-6 text-center text-rizes-limestone sm:mt-12 sm:pt-8">
          <p>&copy; {currentYear} Rizes Sifnos. All rights reserved.</p>
          <p className="mt-2 text-sm text-rizes-limestone/80">
            Web Design & Development by Rizes Project
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
